export enum AuthMode {
  DEVIANTART = 'DA',
  TEST = 'test',
  UNKNOWN = 'unknown',
}

export type AuthModeState = AuthMode;
